export default __webpack_public_path__ + "assets/images/icone-socio6aa260ae252a7b8b8e4bc6262a129fb8.png";